import { render, staticRenderFns } from "./TagsInputWrapper.vue?vue&type=template&id=0af2851f&scoped=true&"
import script from "./TagsInputWrapper.vue?vue&type=script&lang=js&"
export * from "./TagsInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TagsInputWrapper.vue?vue&type=style&index=0&id=0af2851f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2851f",
  null
  
)

export default component.exports